//core
import React, { Component } from 'react'
//material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import FormLabel from "@material-ui/core/FormLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import TextField from '@material-ui/core/TextField';
//dashboard-pro
import GridContainer from "../components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
//components
// import PerfectScrollbar from "perfect-scrollbar";
//bussiness
import CompanysendareaModal from 'global/CompanysendareaModal'
import CompanyareaModal from 'global/CompanyareaModal'
import UploadCard from 'global/UploadCard'
import CommonHttp from 'global/CommonHttp';
//css
// import "filepond/dist/filepond.min.css";
// import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import { dangerColor, infoColor } from "assets/jss/material-dashboard-pro-react.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle";
import { replaceAll, replaceSpaces } from 'global/utils.js';
//image
const rateList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 13, 15, 20, 25]
const style = {
    ...regularFormsStyle,
    ...selectStyles,
    tipsText: { color: dangerColor[1] },
    tipsTextBackground: {
        backgroundColor: infoColor[6],
        border: '1px solid',
        borderColor: infoColor[1],
        padding: '5px 15px',
        borderRadius: '10px'
    },
    currencySelectFormControl: {
        margin: "23px 0 7px 0 !important",
        "& > div": {
            "&:before": {
                borderBottomWidth: "1px !important",
                borderBottomColor: "#D2D2D2!important"
            },
            "&:after": {
                // borderBottomColor: primaryColor[0] + "!important"
                borderBottomColor: "#00acc1!important"
            }
        }
    },
}
let ps;
class Legalperson extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formObj: props.formObj,
            optObj: props.optObj,
            uploadFileName: '',
            uploadFileAllName: ''
        }
        this.onContentChange = this.onContentChange.bind(this);
        this.selectProperty = this.selectProperty.bind(this);
        this.selectCompanyareaid = this.selectCompanyareaid.bind(this);//公司所在地
        this.selectCompanysendareaids = this.selectCompanysendareaids.bind(this);//供货区域
        this.selectSupplierClass = this.selectSupplierClass.bind(this);//供货分类
    }

    onInputChange(keyWords, value) {
        // if (keyWords === 'idcardurl') {
        if (keyWords === 'idcardback' || keyWords === 'idcardfront') {
            this.props.changeFun(keyWords, value.name);
        } else {
            let el
            if (keyWords === 'mobile') {
                el = document.getElementById('companyMobile');
            } else {
                el = document.getElementById(keyWords);
            }
            if (el && el.value && el.value !== this.state.formObj[keyWords]) {
                let curValue = el.value;
                this.props.changeFun(keyWords, curValue);
            }
        }
    }

    onContentChange(keyWords, e) {
        this.props.changeFun(keyWords, e.target.value);
    }

    selectProperty(event) {
        this.props.changeFun('property', event.target.value);
    }

    // selectTypeName(event){
    //     this.props.changeFun('typeName',event.target.value);
    // }

    selectTaxpayerType(event) {
        this.props.changeFun('taxpayerType', event.target.value);
    }

    selectTaxType(event) {
        this.props.changeFun('taxType', event.target.value);
    }

    selectCompanysendareaids(checked, name) {
        this.props.changeFun('companysendareaids', checked, name);
    }

    selectCompanyareaid(name, id) {
        this.props.changeFun('companyareaid', id, name);
    }

    selectSupplierClass(checked, name) {
        this.props.changeFun('supplierClass', checked, name);
    }

    // 文件名称首先拼接路径，格式年/月/日
    // 其次生成一个随机的uuid作为文件名，以免上传的内容重复
    // 最后取上传文件的扩展名
    // 拼接在一起
    getName(filename) {
        let date = new Date();
        let month = date.getMonth() + 1;
        month = month > 9 ? month : '0' + month;
        let dir = date.getFullYear() + '/' + month + '/' + date.getDate() + '/';

        let s = [];
        let hexDigits = "0123456789abcdef";
        for (let i = 0; i < 32; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[12] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[16] = hexDigits.substr((s[16] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        let uuid = s.join("");

        let pos = filename.lastIndexOf('.')
        let suffix = ''
        if (pos !== -1) {
            suffix = filename.substring(pos)
        }
        this.setState({
            uploadFileName: (uuid + suffix),
            uploadFileAllName: (dir + uuid + suffix)
        })
        // (dir + uuid + suffix) : (uuid + suffix)
        // return all ? (dir + uuid + suffix) : (uuid + suffix);
    }

    //生成上传文件签名
    // getSignature (){
    //     let policyText = {
    //         "expiration": "2020-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
    //         "conditions": [
    //             ["content-length-range", 0, 1048576000] // 设置上传文件的大小限制
    //         ]
    //     };
    //     let bytes = Crypto.HMAC(Crypto.SHA1, Base64.encode(JSON.stringify(policyText)), 'yYTtO2VzEN1cbKtsM4US4p9dCEnsQ4', {
    //         asBytes: true
    //     });
    //     return Crypto.util.bytesToBase64(bytes);
    // }

    // componentDidMount(){
    // ps = new PerfectScrollbar('#companyFormContainer', {
    //     suppressScrollX: true,
    //     suppressScrollY: false
    // });
    // }

    componentWillUnmount() {
        ps.destroy();
    }

    render() {
        const { classes } = this.props;
        // let policyText = {
        //     "expiration": "2020-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
        //     "conditions": [
        //         ["content-length-range", 0, 1048576000] // 设置上传文件的大小限制
        //     ]
        // };
        return (
            <div id="companyFormContainer">
                <GridContainer className={classes.tipsText}>
                    <GridItem xs={2} sm={2} md={2}></GridItem>
                    <GridItem xs={8} sm={8} md={8}>
                        <div className={classes.tipsTextBackground}>
                            <div>注意事项：</div>
                            <div>1、恭喜！您的账号已注册成功，请继续完善企业信息。</div>
                            <div>2、带红色*号为必填项</div>
                            <div>3、必须正确填写必填项信息，否则将影响审核</div>
                        </div>
                    </GridItem>
                    <GridItem xs={2} sm={2} md={2}></GridItem>
                </GridContainer>
                <GridContainer id="legalPersonContainer">
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>公司名称
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='supplierName'
                            inputProps={{
                                disabled: true, value: (this.props.formObj.supplierName),
                                // onBlur:this.onInputChange.bind(this,'supplierName'),
                                onChange: (e) => { this.onContentChange('supplierName', e) }
                            }} />
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>单位性质
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <FormControl fullWidth className={classes.selectFormControl}>
                            <Select MenuProps={{ className: classes.selectMenu }}
                                classes={{ select: classes.select }}
                                onChange={e => this.onContentChange('property', e)}
                                value={this.props.formObj.property}
                                inputProps={{
                                    name: "propertySelect",
                                    id: "property"
                                }}>
                                {
                                    this.props.optObj.natureList.map((item) => {
                                        return <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }} value={item.id}>{item.name}</MenuItem>
                                    })
                                }
                                {/* <MenuItem classes={{root: classes.selectMenuItem,selected: classes.selectMenuItemSelected}} 
                                        value="1">国有企业</MenuItem>
                                    <MenuItem classes={{root: classes.selectMenuItem,selected: classes.selectMenuItemSelected}} 
                                        value="2">外资企业</MenuItem>
                                    <MenuItem classes={{root: classes.selectMenuItem,selected: classes.selectMenuItemSelected}} 
                                        value="3">集体企业</MenuItem>
                                    <MenuItem classes={{root: classes.selectMenuItem,selected: classes.selectMenuItemSelected}} 
                                        value="4">私营企业</MenuItem>
                                    <MenuItem classes={{root: classes.selectMenuItem,selected: classes.selectMenuItemSelected}} 
                                        value="5">联营企业</MenuItem>
                                    <MenuItem classes={{root: classes.selectMenuItem,selected: classes.selectMenuItemSelected}} 
                                        value="6">股份合作公司</MenuItem>
                                    <MenuItem classes={{root: classes.selectMenuItem,selected: classes.selectMenuItemSelected}} 
                                        value="7">股份有限公司</MenuItem>
                                    <MenuItem classes={{root: classes.selectMenuItem,selected: classes.selectMenuItemSelected}} 
                                        value="8">有限责任公司</MenuItem>
                                    <MenuItem classes={{root: classes.selectMenuItem,selected: classes.selectMenuItemSelected}} 
                                        value="9">其他</MenuItem> */}
                            </Select>
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>注册资金（万）
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={2}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='registerCapital'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.registerCapital),
                                type: 'number',
                                onChange: (e) => {
                                    this.onContentChange('registerCapital', {
                                        target: {
                                            value: replaceAll(e.target.value, /\d/g)
                                        }
                                    })
                                }
                            }} />
                        <div className='tips' style={{
                            position: 'absolute',
                        }}>提示：请正确填写注册资金，例：1000000元的资金，应填写为100</div>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={1}>
                        <FormControl fullWidth className={classes.currencySelectFormControl}>
                            <Select MenuProps={{ className: classes.selectMenu }}
                                classes={{ select: classes.select }}
                                onChange={e => this.onContentChange('currency', e)}
                                value={this.props.formObj.currency}
                                inputProps={{}}>
                                {/* 默认人名币 */}
                                {
                                    this.props.optObj.currencyList.map((item) => {
                                        return <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }} value={item.id}>{item.name}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>企业类型
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <FormControl fullWidth className={classes.selectFormControl}>
                            <Select MenuProps={{ className: classes.selectMenu }}
                                classes={{ select: classes.select }}
                                onChange={e => this.onContentChange('typeName', e)}
                                value={this.props.formObj.typeName}
                                inputProps={{}}>
                                <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}
                                    value="1">生产商</MenuItem>
                                <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}
                                    value="2">经销商/代理商</MenuItem>
                                <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}
                                    value="3">其他</MenuItem>
                            </Select>
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>统一信用代码/组织机构代码
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='orgnizationCode'
                            inputProps={{
                                disabled: true, value: (this.props.formObj.orgnizationCode),
                                // onBlur:this.onInputChange.bind(this,'orgnizationCode')}}
                                onChange: (e) => { this.onContentChange('orgnizationCode', e) }
                            }} />
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>工商注册号</FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='regNumber'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.regNumber),
                                onChange: (e) => { this.onContentChange('regNumber', e) }
                            }} />
                    </GridItem>
                    {/* <GridItem xs={8} sm={8} md={3}>
                        <FormLabel style={{float:'none'}} className={classes.labelHorizontal}>注：个体工商户此处请填写营业执照号。</FormLabel>
                    </GridItem> */}
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>税务登记号
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='businesslicense'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.businesslicense),
                                onChange: (e) => { this.onContentChange('businesslicense', e) }
                            }} />
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}><span className={classes.validationSymbol}>*</span>供货区域</FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={2}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='companysendareaids'
                            inputProps={{ className: 'long-input', disabled: true, value: (this.props.formObj.companysendarea) }} />
                    </GridItem>
                    <GridItem xs={8} sm={8} md={1}>
                        <CompanysendareaModal openSnackbar={this.props.openSnackbar} selectTree={this.selectCompanysendareaids}
                            selectedNodeText={this.props.formObj.companysendarea}
                            selectedNode={this.props.formObj.companysendareaids} type='companysendareaids' />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    {/* <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}><span className={classes.validationSymbol}>*</span>供货类别</FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={2}>
                        <CustomInput formControlProps={{fullWidth: true}} id='supplierClass'
                            inputProps={{className:'long-input',disabled: true,value:(this.props.formObj.supplierClassName)}}/>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={1}>
                        <CompanysendareaModal openSnackbar={this.props.openSnackbar} selectTree={this.selectSupplierClass}
                            selectedNodeText={this.props.formObj.supplierClassName}
                            selectedNode={this.props.formObj.supplierClass} type='supplierClass'/>
                    </GridItem> */}

                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}><span className={classes.validationSymbol}>*</span>公司所在地</FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={2}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='companyareaid'
                            inputProps={{ className: 'long-input', disabled: true, value: (this.props.formObj.companyarea) }} />
                    </GridItem>
                    <GridItem xs={8} sm={8} md={1}>
                        <CompanyareaModal openSnackbar={this.props.openSnackbar} selectArea={this.selectCompanyareaid}
                            selectedNodeText={this.props.formObj.companyarea}
                            selectedNode={this.props.formObj.companyareaid} type='companyareaid' />
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>公司电话</FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='phone'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.phone),
                                onChange: (e) => { this.onContentChange('phone', e) }
                            }} />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>公司传真</FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='fax'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.fax),
                                onChange: (e) => { this.onContentChange('fax', e) }
                            }} />
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}><span className={classes.validationSymbol}>*</span>公司详细地址</FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='address'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.address),
                                onChange: (e) => { this.onContentChange('address', e) }
                            }} />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>邮政编码</FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='zipCode'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.zipCode),
                                onChange: (e) => { this.onContentChange('zipCode', e) }
                            }} />
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>企业网址</FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='website'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.website),
                                onChange: (e) => { this.onContentChange('website', e) }
                            }} />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>公司联系人
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='contactPerson'
                            inputProps={{
                                disabled: true, value: (this.props.formObj.contactPerson),
                                onChange: (e) => { this.onContentChange('contactPerson', e) }
                            }} />
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>联系人电话
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='companyMobile'
                            inputProps={{
                                disabled: true, value: (this.props.formObj.mobile),
                                onChange: (e) => { this.onContentChange('mobile', e) }
                            }} />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>纳税人类型
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <FormControl fullWidth className={classes.selectFormControl}>
                            <Select MenuProps={{ className: classes.selectMenu }}
                                classes={{ select: classes.select }}
                                onChange={e => this.onContentChange('taxpayerType', e)}
                                value={this.props.formObj.taxpayerType}
                                inputProps={{}}>
                                {
                                    this.props.optObj.transactionList.map((item) => {
                                        return <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }} value={item.id}>{item.name}</MenuItem>
                                    })
                                }
                                {/* <MenuItem classes={{root: classes.selectMenuItem,selected: classes.selectMenuItemSelected}} 
                                            value="1">一般纳税人</MenuItem>
                                        <MenuItem classes={{root: classes.selectMenuItem,selected: classes.selectMenuItemSelected}} 
                                            value="2">小规模纳税人</MenuItem> */}
                            </Select>
                        </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>纳税人税率
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={2}>
                        <FormControl fullWidth className={classes.currencySelectFormControl}>
                            <Select MenuProps={{ className: classes.selectMenu }}
                                classes={{ select: classes.select }}
                                onChange={e => this.onContentChange('taxType', e)}
                                value={this.props.formObj.taxType}
                                inputProps={{}}>
                                {
                                    rateList.map(__ => <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value={`${__}`}>{__}%</MenuItem>
                                    )
                                }
                                {/* <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}
                                    value="0">0%</MenuItem>
                                <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}
                                    value="3">3%</MenuItem>
                                <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}
                                    value="6">6%</MenuItem>
                                <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}
                                    value="9">9%</MenuItem> */}
                                {/* <MenuItem classes={{root: classes.selectMenuItem,selected: classes.selectMenuItemSelected}} 
                                        value="3">11%增值专票</MenuItem> */}
                                {/* <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}
                                    value="13">13%</MenuItem> */}
                                {/* <MenuItem classes={{root: classes.selectMenuItem,selected: classes.selectMenuItemSelected}} 
                                        value="5">17</MenuItem> */}
                                {/* <MenuItem classes={{root: classes.selectMenuItem,selected: classes.selectMenuItemSelected}} 
                                        value="8">11%增值普票</MenuItem> */}
                                {/* <MenuItem classes={{root: classes.selectMenuItem,selected: classes.selectMenuItemSelected}} 
                                        value="9">13</MenuItem> */}
                                {/* <MenuItem classes={{root: classes.selectMenuItem,selected: classes.selectMenuItemSelected}} 
                                        value="10">17%增值普票</MenuItem> */}
                            </Select>
                        </FormControl>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={1}>
                        <FormControl fullWidth className={classes.currencySelectFormControl}>
                            <Select MenuProps={{ className: classes.selectMenu }}
                                classes={{ select: classes.select }}// 税总
                                onChange={e => this.onContentChange('taxTypeId', e)}
                                value={this.props.formObj.taxTypeId}
                                inputProps={{}}>
                                {
                                    this.props.optObj.categoryList.map((item) => {
                                        return <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }} value={item.id}>{item.name}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>开户行名称
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='openBankName'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.openBankName),
                                placeholder:"请输入办理开户手续的银行营业网点",
                                onChange: (e) => {
                                    this.onContentChange('openBankName', {
                                        target: {
                                            value: replaceSpaces(e.target.value)
                                        }
                                    })
                                }
                            }} />
                        <span className='tips'>提示：请输入正确的办理开户的银行营业网点</span>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>开户银行地址
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='openBankAddress'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.openBankAddress),
                                onChange: (e) => { this.onContentChange('openBankAddress', e) }
                            }} />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>银行账号
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='bankNumber'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.bankNumber),
                                onChange: (e) => {
                                    this.onContentChange('bankNumber', {
                                        target: {
                                            value: replaceAll(e.target.value, /\d/g)
                                        }
                                    })
                                }
                            }} />
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>开户行联行号
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={2}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='unionPayNumber'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.unionPayNumber),
                                onChange: (e) => {
                                    this.onContentChange('unionPayNumber', e)
                                },
                                onBlur: (e) => {
                                    const unionPayBumber = `${e.target.value}`;
                                    if (unionPayBumber.length !== 12) return;
                                    CommonHttp.get(`/shared-base-data/basic/v1/dictionaries/financialInstitution/about?number=${unionPayBumber}`).then(( data ) => {
                                        if (data) {
                                            const { name } = data;
                                            if (name) {
                                                this.onContentChange('openBankName', {
                                                    target: {
                                                        value: name
                                                    }
                                                })
                                            }
                                        }
                                    });
                                }
                            }} />
                    </GridItem>
                    <GridItem xs={8} sm={8} md={1}>
                        <a style={{ position: 'relative', top: '24px' }} target='_blank' rel="noopener noreferrer" href="http://www.lianhanghao.com">联行号查询</a>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>是否上市公司
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <FormControl fullWidth className={classes.currencySelectFormControl}>
                            <Select MenuProps={{ className: classes.selectMenu }}
                                classes={{ select: classes.select }}
                                onChange={e => this.onContentChange('listedCompany', e)}
                                value={this.props.formObj.listedCompany}
                                inputProps={{}}>
                                <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}
                                    value="0">否</MenuItem>
                                <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}
                                    value="1">是</MenuItem>
                            </Select>
                        </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>公司所在国家
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <FormControl fullWidth className={classes.currencySelectFormControl}>
                            <Select MenuProps={{ className: classes.selectMenu }}
                                classes={{ select: classes.select }}
                                onChange={e => this.onContentChange('countryId', e)}
                                value={this.props.formObj.countryId}
                                inputProps={{}}>
                                {
                                    this.props.optObj.companyList.map((item) => {
                                        return <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }} value={item.id}>{item.name}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>成立日期
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <FormControl fullWidth className={classes.selectFormControl}>
                            <TextField
                                id="date"
                                onChange={e => this.onContentChange('buildTime', e)}
                                value={this.props.formObj.buildTime}
                                type="date"
                                // defaultValue="2017-05-24"
                                className={classes.textField}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>所属行业
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <FormControl fullWidth className={classes.currencySelectFormControl}>
                            <Select MenuProps={{ className: classes.selectMenu }}
                                classes={{ select: classes.select }}
                                onChange={e => this.onContentChange('industryId', e)}
                                value={this.props.formObj.industryId}
                                inputProps={{}}>
                                {
                                    this.props.optObj.industryList.map((item) => {
                                        return <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }} value={item.id}>{item.name}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>经济类型
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <FormControl fullWidth className={classes.currencySelectFormControl}>
                            <Select MenuProps={{ className: classes.selectMenu }}
                                classes={{ select: classes.select }}
                                onChange={e => this.onContentChange('claEconomicId', e)}
                                value={this.props.formObj.claEconomicId}
                                inputProps={{}}>
                                {
                                    this.props.optObj.enconomicList.map((item) => {
                                        return <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }} value={item.id}>{item.name}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>银行账户类型
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <FormControl fullWidth className={classes.currencySelectFormControl}>
                            <Select MenuProps={{ className: classes.selectMenu }}
                                classes={{ select: classes.select }}
                                onChange={e => this.onContentChange('accountTypeId', e)}
                                value={this.props.formObj.accountTypeId}
                                inputProps={{}}>
                                {
                                    this.props.optObj.classificationList.map((item) => {
                                        return <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }} value={item.id}>{item.name}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>开户名
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='accountName'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.accountName),
                                onChange: (e) => {
                                    this.onContentChange('accountName', {
                                        target: {
                                            value: replaceSpaces(e.target.value)
                                        }
                                    })
                                }
                            }} />
                        <span className='tips'>提示：请输入开户时的个人或者单位名称</span>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>银行账户币种
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <FormControl fullWidth className={classes.currencySelectFormControl}>
                            <Select MenuProps={{ className: classes.selectMenu }}
                                classes={{ select: classes.select }}
                                onChange={e => this.onContentChange('currencyId', e)}
                                value={this.props.formObj.currencyId}
                                inputProps={{}}>
                                {
                                    this.props.optObj.currencyList.map((item) => {
                                        return <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }} value={item.id}>{item.name}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>法人姓名
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='representative'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.representative),
                                onChange: (e) => { this.onContentChange('representative', e) }
                            }} />
                    </GridItem>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}><span className={classes.validationSymbol}>*</span>法人身份证号</FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='idCard'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.idCard),
                                placeholder:'请填写正确的身份证号码',
                                onChange: (e) => { this.onContentChange('idCard', e) }
                            }} />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>法人电话
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='representativeTel'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.representativeTel),
                                onChange: (e) => { this.onContentChange('representativeTel', e) }
                            }} />
                    </GridItem>

                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal + " " + classes.huaxiLabel}>
                            <span className={classes.validationSymbol}>*</span>发票地址
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{
                            fullWidth: true,
                            className: classes.huaxiInput
                        }} id='invoiceAddr'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.invoiceAddr),
                                onChange: (e) => this.onContentChange('invoiceAddr', e)
                            }} />
                    </GridItem>
                </GridContainer>

                {/* 2022-10-30 新增需求 */}
                <GridContainer>

                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal + " " + classes.huaxiLabel}>
                            <span className={classes.validationSymbol}>*</span>发票通讯电话
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{
                            fullWidth: true,
                            className: classes.huaxiInput
                        }} id='invoicePhone'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.invoicePhone),
                                onChange: (e) => this.onContentChange('invoicePhone', e)
                            }} />
                    </GridItem>

                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal + " " + classes.huaxiLabel}>
                            <span className={classes.validationSymbol}>*</span>发票开户银行联行号
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{
                            fullWidth: true,
                            className: classes.huaxiInput
                        }} id='invoicePayNumber'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.invoicePayNumber),
                                onChange: (e) => this.onContentChange('invoicePayNumber', e),
                                maxLength: 12
                            }} />
                    </GridItem>
                </GridContainer>

                <GridContainer>

                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal + " " + classes.huaxiLabel}>
                            <span className={classes.validationSymbol}>*</span>发票开户银行名称
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{
                            fullWidth: true,
                            className: classes.huaxiInput
                        }} id='invoiceBankName'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.invoiceBankName),
                                onChange: (e) => this.onContentChange('invoiceBankName', {
                                    target: {
                                        value: replaceSpaces(e.target.value)
                                    }
                                })
                            }} />
                    </GridItem>

                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal + " " + classes.huaxiLabel}>
                            <span className={classes.validationSymbol}>*</span>发票开户账号
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <CustomInput formControlProps={{
                            fullWidth: true,
                            className: classes.huaxiInput
                        }} id='invoiceBankNumber'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.invoiceBankNumber),
                                onChange: (e) => this.onContentChange('invoiceBankNumber', e)
                            }} />
                    </GridItem>
                </GridContainer>


                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}><span className={classes.validationSymbol}>*</span>身份证电子版</FormLabel>
                    </GridItem>
                    <GridItem style={{ marginTop: '10px' }} xs={8} sm={8} md={4}>
                        <UploadCard openSnackbar={this.props.openSnackbar} className='idcard front' fileList={this.props.formObj.idcardfront} btnClassName=''
                            uploadSuccess={(url) => this.onInputChange('idcardfront', url)} type='idcardfront' />
                        <UploadCard openSnackbar={this.props.openSnackbar} className='idcard back' fileList={this.props.formObj.idcardback} btnClassName=''
                            uploadSuccess={(url) => this.onInputChange('idcardback', url)} type='idcardback' />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>主营业务
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={8}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='primarybusiness'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.primarybusiness),
                                onChange: (e) => { this.onContentChange('primarybusiness', e) }
                            }} />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>企业简介
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={8}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='introduction'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.introduction),
                                onChange: (e) => { this.onContentChange('introduction', e) }
                            }} />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={4} sm={4} md={2}>
                        <FormLabel className={classes.labelHorizontal}>售后服务</FormLabel>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={8}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='laterContent'
                            inputProps={{
                                disabled: false, value: (this.props.formObj.laterContent),
                                onChange: (e) => { this.onContentChange('laterContent', e) }
                            }} />
                    </GridItem>
                </GridContainer>
            </div>
        )
    }
}

// export default withStyles(regularFormsStyle)(Legalperson);
export default withStyles(style)(Legalperson);